import { render, staticRenderFns } from "./FreeCreation.vue?vue&type=template&id=229ee7a8&"
import script from "./FreeCreation.vue?vue&type=script&lang=js&"
export * from "./FreeCreation.vue?vue&type=script&lang=js&"
import style0 from "./FreeCreation.vue?vue&type=style&index=0&id=229ee7a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports